import { render } from "./ParallaxContactUs.vue?vue&type=template&id=68beea47&scoped=true"
import script from "./ParallaxContactUs.vue?vue&type=script&lang=js"
export * from "./ParallaxContactUs.vue?vue&type=script&lang=js"

import "./ParallaxContactUs.vue?vue&type=style&index=0&id=68beea47&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68beea47"]])

export default __exports__